/**
 * 字段分级码生成时机
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 字段分级码生成时机
 */
enum ElementPathGenerateType {
    /**
     * 创建时
     */
    CreateNode = 'CreateNode',

    /**
     * 保存时
     */
    SaveNode = 'SaveNode',
}

export { ElementPathGenerateType };

